import { render, staticRenderFns } from "./desk.vue?vue&type=template&id=055cd369&scoped=true&"
import script from "./desk.vue?vue&type=script&lang=js&"
export * from "./desk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cd369",
  null
  
)

export default component.exports